var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"modal",attrs:{"name":_vm.name,"pivotY":0.1,"width":300,"height":"auto","overlayTransition":""},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('div',{staticClass:"text"},[_vm._t("default")],2),_c('div',{staticClass:"buttons"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }